/**
 * Clone and append function.
 * 
 * @param {string} trigger - The trigger element selector.
 * @param {string} cloneTarget - The element to be cloned selector.
 * @param {string} appendTarget - The target element to append the cloned element selector.
 * @param {function} callback - The callback function to be executed after cloning and appending.
 */
function cloneAndAppend (trigger, cloneTarget, appendTarget, callback) {
  var targetClass = cloneTarget.replace('.', '');
  var newTargetClass = `.new_${targetClass}`;
  $(document).on('click', trigger, function (e) {
    var item_count = $(appendTarget).find(newTargetClass) ? $(appendTarget).find(newTargetClass).length : 1;
    item_count++;
    e.preventDefault();
    var clonedRow = $(cloneTarget).clone();
    $(clonedRow).addClass(`new_${cloneTarget.replace('.', '')}`).removeClass(targetClass).find('input').val('').end().find('.item-actions');
    $(clonedRow).removeAttr('style');
    $(clonedRow).find('select').each(function(i,o) {
      if ($(this).attr('id')){ 
        // Fixes any selects with id's that may clash
        var currentId = $(this).attr('id');
        $(this).attr('id', currentId.replace('[]', `[${item_count}]`));  
      }
      $(this).removeAttr('data-no-select2');
      $(this).select2({
        placeholder: $(this).attr('placeholder') ?$ (this).attr('placeholder') : '',
        width: 'resolve',
        allowClear: true
      });
    });
    if (callback) callback(clonedRow);
    $(clonedRow).find('[data-date]').each( function() {
      $(this).attr("id", "date_input-" + item_count).datetimepicker({
        widgetPositioning: {
          vertical: "bottom",
          horizontal: "auto"
        }
      });
    });
    $(clonedRow).appendTo(appendTarget);
  });
}
window.cloneAndAppend = cloneAndAppend;